import React, { useEffect, useState } from 'react'
import { TwPage } from '../../../components/TailwindPage'
import { useNavigate, useParams } from 'react-router-dom';
import { ButtonV2, CoreButtonTypes, useModalHelper, useToastAction } from '@metaforcelabs/metaforce-core';
import { createDistributionListAlternative, deleteDistributionListAlternative, disableDistributionListAlternative, enableDistributionListAlternative, getDistributionList, getDistributionListAlternatives, updateDistributionList, updateDistributionListAlternative } from '../../../api/distributionLists';
import Card, { CardHeader } from '../../../components/Card';
import { Textbox } from '../../../components/Textbox';
import DistributionListStatusBadge, { DistributionListsStatus } from '../../../components/DistributionListStatusBadge';
import MenuContextListV2 from '../../../components/MenuContextListV2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPen, faPlay, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useDebounceCallback } from '@react-hook/debounce';
import { Formik } from 'formik';
import GenericModal from '../../../components/Modals/genericModal';
import * as yup from 'yup';

export default function DistributionAlternatives() {
    const { id } = useParams();
    const loadAction = useToastAction(false);
    const saveAction = useToastAction(false);
    const [distribution, setDistribution] = useState()
    const [alternatives, setAlternatives] = useState([]);
    const distributionAlternativeModalHelper = useModalHelper();
    const navigate = useNavigate();

    const load = async () => {
        await loadAction.executeAsync(async () => {
            const [list, alternatives] = await Promise.all([getDistributionList(id), getDistributionListAlternatives(id)]);
            setDistribution(list);
            setAlternatives(alternatives);
            console.log(list, alternatives)
        }, 'Failed to load distribution list')
    }

    useEffect(() => {
        load();
    }, []);

    useEffect(() => {
        if (!distributionAlternativeModalHelper.isOpen) {
            distributionAlternativeModalHelper.setActivetItem(null);
        }
    }, [distributionAlternativeModalHelper.isOpen])

    const handleSaveDistribution = async () => {

        if (!distribution || !distribution.name) return;

        await saveAction.executeAsync(async () => {
            // Assuming you have an API endpoint to update the distribution list
            // await updateDistributionList(distribution.id, { name: distribution.name });            
            //debounce the save action
            const updatedDistribution = await updateDistributionList({ id: distribution.id, name: distribution.name });
            setDistribution(updatedDistribution);
            console.log('Saving distribution:', distribution);
        }, 'Failed to save distribution name');
    }

    const debounceSave = useDebounceCallback(handleSaveDistribution, 1000);

    const handleNameChange = ({ target }) => {
        setDistribution(prev => ({ ...prev, name: target.value }));
        debounceSave();
    }

    const handleCreateDistributionAlternative = async (values) => {
        await saveAction.executeAsync(async () => {
            const newAlternative = await createDistributionListAlternative(id, values);
            setAlternatives(prev => [...prev, newAlternative]);
        }, 'Failed to create distribution alternative');
    }

    const handleUpdateDistributionAlternative = async (values) => {
        await saveAction.executeAsync(async () => {
            const updated = await updateDistributionListAlternative(id, values);
            handleDistributionListAlternativeUpdate(updated);
            setAlternatives(prev => prev.map(alternative => alternative.id === updated.id ? updated : alternative));

        }, 'Failed to create distribution alternative');
    }

    const handleDistributionListAlternativeUpdate = (updated) => {
        setAlternatives(prev => prev.map(alternative => alternative.id === updated.id ? updated : alternative));
    }


    const handleDisableDistributionAlternative = async (alternative) => {
        await saveAction.executeAsync(async () => {
            const updated = await disableDistributionListAlternative(id, alternative.id);
            handleDistributionListAlternativeUpdate(updated);
        }, 'Failed to disable distribution alternative');
    }

    const handleEnableDistributionAlternative = async (alternative) => {
        await saveAction.executeAsync(async () => {
            const updated = await enableDistributionListAlternative(id, alternative.id);
            handleDistributionListAlternativeUpdate(updated);
        }, 'Failed to enable distribution alternative');
    }

    const handleDeleteDistributionAlternative = async (alternative) => {
        await saveAction.executeAsync(async () => {
            await deleteDistributionListAlternative(id, alternative.id);
            setAlternatives(prev => prev.filter(a => a.id !== alternative.id));

        }, 'Failed to delete distribution alternative');
    }


    return (
        <TwPage>
            <TwPage.Header>
                <TwPage.Header.Hdr.Fixed
                    title="Distribution"
                // description={"Manage distribution"}
                />
                <TwPage.Header.Hdr.Buttons >
                    <ButtonV2
                        label="Back"
                        type={CoreButtonTypes.secondary}
                        onClick={() => {
                            navigate('/distribution');
                        }} />
                </TwPage.Header.Hdr.Buttons>
            </TwPage.Header>
            <Card
                title="Manage Distribution"
                // subtitle="Manage distribution"
                removeBodyXPadding={true}
                headerBorder={true}
                headerActions={
                    <>
                        <DistributionListStatusBadge status={distribution?.status} />
                    </>
                }
            >
                <div className='space-y-4 divide-y divide-gray-300 dark:divide-gray-500'>
                    <div className='dark:border-gray-500 px-4 -mt-4 text-gray-500 dark:text-gray-300'>
                        <div className='max-w-2xl'>
                            <Textbox
                                label="Name"
                                placeholder="Enter distribution list name"
                                value={distribution?.name || ''}
                                name="distributionListName"
                                onChange={(event) => {
                                    handleNameChange(event);
                                }}
                            />
                        </div>
                    </div>
                    <div>
                        <div>
                            <CardHeader title={"Distribution alternatives"} headerBorder={false}
                                headerActions={
                                    <>
                                        <ButtonV2 label={'New'} type={CoreButtonTypes.cta}
                                            onClick={() => { distributionAlternativeModalHelper.open() }}
                                        />
                                    </>
                                }
                            />
                            {/* Table */}
                            <div className='relative'>
                                <div className="overflow-hidden ">
                                    <table className="min-w-full divide-y divide-gray-200 dark:divide-gray-500">
                                        <thead className="bg-gray-50 dark:bg-gray-600">
                                            <tr>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                                    #
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                                    Name
                                                </th>
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                                    Status
                                                </th>
                                                <th scope="col" className="px-6 py-3 max-w-xs text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                                    Description
                                                </th>
                                                {/* <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                            CREATED DATE
                                        </th> */}
                                                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wider">
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody className="bg-white dark:bg-gray-700 divide-y divide-gray-200 dark:divide-gray-500">
                                            {alternatives?.map((alternative) => (
                                                <tr key={alternative.id} className="hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-150">
                                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 dark:text-gray-100 font-medium">
                                                        {alternative.code}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <div className="flex items-center">
                                                            <div
                                                                className="text-sm font-medium text-gray-700 dark:text-gray-100 cursor-pointer hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors duration-150"
                                                                onClick={() => {
                                                                    distributionAlternativeModalHelper.setActivetItem(alternative);
                                                                    distributionAlternativeModalHelper.open();
                                                                }}
                                                            >
                                                                {alternative.name}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap">
                                                        <DistributionListStatusBadge status={alternative.status} />
                                                    </td>
                                                    <td className="px-6 py-4 max-w-xs text-sm text-gray-700 dark:text-gray-100">
                                                        {alternative.description || ''}
                                                    </td>
                                                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium text-gray-500 dark:text-gray-400">

                                                        <MenuContextListV2
                                                            actions={[
                                                                {
                                                                    name: 'Edit',
                                                                    onClick: () => {
                                                                        distributionAlternativeModalHelper.setActivetItem(alternative);
                                                                        distributionAlternativeModalHelper.open();
                                                                    },
                                                                    disabled: false,
                                                                    icon: ({ className }) => (
                                                                        <FontAwesomeIcon
                                                                            icon={faPen}
                                                                            className={className}
                                                                        />
                                                                    ),
                                                                },
                                                                {
                                                                    name: alternative.status === DistributionListsStatus.active ? 'Disable' : 'Enable',
                                                                    onClick:
                                                                        () => {
                                                                            alternative.status === DistributionListsStatus.active ?
                                                                                handleDisableDistributionAlternative(alternative) :
                                                                                handleEnableDistributionAlternative(alternative)
                                                                        },
                                                                    disabled: false,
                                                                    icon: ({ className }) => (
                                                                        <FontAwesomeIcon
                                                                            icon={alternative.status === DistributionListsStatus.active ? faPause : faPlay}
                                                                            className={className}
                                                                        />
                                                                    ),
                                                                },
                                                                {
                                                                    name: 'Delete',
                                                                    onClick: () => {
                                                                        handleDeleteDistributionAlternative(alternative);
                                                                    },
                                                                    disabled: alternative.status === DistributionListsStatus.active,
                                                                    icon: ({ className }) => (
                                                                        <FontAwesomeIcon icon={faTrash} className={className} />
                                                                    ),
                                                                }
                                                            ]}
                                                            element={alternative}
                                                            deleteType={"Distribution Alternative"}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {alternatives.length === 0 && (
                            <div className="text-center py-12">
                                <h3 className="mt-2 text-sm font-medium text-gray-900 dark:text-white">No distribution alternatives</h3>
                                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">Get started by adding new distribution alternative</p>
                            </div>
                        )}
                    </div>
                </div>
            </Card>
            <DistributionAlternativeModal
                modalHelper={distributionAlternativeModalHelper}
                onSave={async (values, mode) => {
                    if (mode === 'edit') {
                        await handleUpdateDistributionAlternative(values);
                    } else {
                        await handleCreateDistributionAlternative(values);
                    }
                }}
            />
        </TwPage>
    )
}


const DistributionAlternativeModal = ({ modalHelper, onSave }) => {
    const mode = modalHelper.activeItem ? 'edit' : 'create';

    const handleSubmit = async (values) => {
        await onSave(values, mode)
        modalHelper.close();
    }

    const { id, code, name, description } = modalHelper.activeItem || { id: null, code: '', name: '', description: '' };

    return (
        <GenericModal
            open={modalHelper.isOpen}
            setOpen={open => open ? modalHelper.open : modalHelper.close()}
            title="New Distribution Alternative"
            confirmButtonText='Create'
            showCancelButton={false}
            showConfirmButton={false}
        >
            <div className='text-left'>
                <DistributionAlternativeForm
                    distributionAlternative={{ id, code, name, description }}
                    mode={mode}
                    onSubmit={async (values) => {
                        await handleSubmit(values);
                    }}
                    onCancel={() => {
                        modalHelper.close();
                    }}

                />

            </div>

        </GenericModal>
    )
}

const DistributionAlternativeForm = ({ distributionAlternative, onSubmit, onCancel, mode = 'edit' }) => {

    return (
        <Formik
            initialValues={distributionAlternative}
            validationSchema={
                yup.object().shape(
                    {
                        code: yup.string().required('Code is required').min(2, 'Min 2 characters').max(10, 'Max 10 characters'),
                        name: yup.string().required('Name is required').min(3, 'Min 2 characters').max(40, 'Max 40 characters'),
                        description: yup.string().optional().max(250, 'Max 250 characters'),
                    }
                )
            }
            enableReinitialize={true}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                onSubmit(values);
                setSubmitting(false);
            }}
        >
            {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, errors, touched }) => (
                <form onSubmit={handleSubmit}>
                    <div className="space-y-4">
                        <div className='grid grid-cols-4 gap-4'>
                            <div>
                                <Textbox
                                    label="#"
                                    name="code"
                                    error={touched.code && errors.code}
                                    value={values.code}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter code..."
                                />
                            </div>
                            <div className='col-span-3'>
                                <Textbox
                                    label="Name"
                                    name="name"
                                    error={touched.name && errors.name}
                                    value={values.name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    placeholder="Enter name..."
                                />
                            </div>
                        </div>
                        <Textbox
                            label="Description"
                            name="description"
                            value={values.description}
                            error={touched.description && errors.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            placeholder="Enter description..."
                        />
                        {/* Add more fields as needed */}
                    </div>
                    <div className='grid grid-cols-2 gap-4 mt-8 -mb-4'>
                        <ButtonV2
                            type={CoreButtonTypes.secondary}
                            label="Cancel"
                            disabled={isSubmitting}
                            htmlType='button'
                            onClick={() => {
                                // Logic to close the modal or reset the form
                                onCancel()
                            }}
                        />
                        <ButtonV2
                            type={CoreButtonTypes.cta}
                            htmlType='submit'
                            label={mode === 'edit' ? 'Update' : 'Create'}
                            disabled={isSubmitting}
                        />
                    </div>
                </form>
            )}
        </Formik>
    )
}
